import type { ListBuilderList } from '../../../types';
import { createTripColumnsWithoutDate } from '../columns';

/**
 * Today's Routes list configuration
 * Shows routes scheduled for today
 */
export const todaysTripsList: ListBuilderList = {
	id: 'todays-trips',
	name: "Today's Trips",
	type: 'default',
	active: true,
	cacheTTL: 300000,
	filterRules: {
		routeDateFrom: {
			defaultValue: [{ id: '{{TODAY}}', label: 'Today' }],
		},
		routeDateTo: {
			defaultValue: [{ id: '{{TODAY}}', label: 'Today' }],
		},
	},
	columns: createTripColumnsWithoutDate(),
	defaultSortId: 'status-asc',
	sortOrder: 1,
};
